/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import styles from './SourcesSection.module.scss';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { SourcesSectionProps } from './SourcesSection.types';

export const SourcesSection = ({ guides, className }: SourcesSectionProps) => {
  const { t } = useInt();

  if (!guides.length) {
    return null;
  }

  return (
    <SectionShell id="sources" title={t('Sources & further reading')} className={className}>
      <ul className={styles['list']}>
        {guides.map((guide) => (
          <li key={guide.slug} className={styles['item']}>
            <a href={guide.url} target="_blank" rel="noopener noreferrer" className={styles['link']}>
              {guide.title}
            </a>

            {guide.desc && <span className={styles['desc']}>{guide.desc}</span>}
          </li>
        ))}
      </ul>
    </SectionShell>
  );
};
